// Description: this "ReadMoreComponent" component applies to any string to show see more... see less.. functionality
// Created by : Saroj Kumar        Date: 22-Nov-2017
// Purpose: to apply <show more ... show less> functionality to any string description.
// Input parameters: all input parameters are optional by default.
//                 [text] : string description
//                 [maxLength]: number of string to be shown to appear toggle button <see more>
//                 [showToggleButton]: boolean value set to true to show toggle button
//                 [id] : id is used to generate dynamic id of the dom element in which description is shown. It is mandatory to use input param 
//                          while showing the description in loop.
// format to apply:  <read-more [text]= "string description" [maxLength]="100" [showToggleButton]="true"> </read-more>
//                 for loop: <read-more [id]="id from object" [text]= "string description" [maxLength]="100" [showToggleButton]="true"> </read-more>
// 
//  <a (click)="toggleView()">See {{isCollapsed? 'more':'less'}}</a>  //////
//

import { Component, OnInit, Input, ElementRef, OnChanges } from '@angular/core';
import { BaseService } from '../../shared-service/base.service';
import { WindowRef } from '../../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Component({    
  selector: 'read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.css']
})

export class ReadMoreComponent implements  OnChanges {  

  @Input('text') text: string = '';
  @Input('maxLength') maxLength: number = 200;
  @Input('showToggleButton')showToggleButton:boolean = true;
  @Input('id') id: string = '';

  currentText: string|any;

  public isCollapsed: boolean = true;

  constructor(public bs:BaseService ,private winRef:WindowRef         
      //private elementRef: ElementRef
  ) {
    $('.c').on("click", function(event:any) {
        event.preventDefault();
        event.stopPropagation();
        }, false);
  }
  toggleView() {
      this.isCollapsed = !this.isCollapsed;
      this.determineView();
    
  }



  determineView() {
    setTimeout(() => {

        if (this.text.length <= this.maxLength) {
            this.currentText = this.text;
            this.isCollapsed = false;         
            this.winRef.nativeWindow.document.getElementById("a"+this.id).style.visibility = "hidden"; 
            return;
        }

        if (this.isCollapsed == true) { 
            this.currentText = this.text.replace(/<[^>]+>/g, '').substring(0, this.maxLength) + " ...";          
        } else if(this.isCollapsed == false)  {
            this.currentText = this.text;
        }
        this.winRef.nativeWindow.document.getElementById("a"+this.id).style.visibility = "visible";         
    }, 0);

  }

  ngOnChanges() {
   
      this.id = this.id != '' ? this.id : '';
      if(!this.validateSource(this.text)) {
          //throw 'Source must be a string.';
          this.bs.log('error','Source must be a string.');
      }
      else{
        this.isCollapsed = true;
          this.determineView();
      }
  }

  validateSource(s:any) {
      if(typeof s !== 'string') {
          return true;  // valid for any type
      } else {
          return true;
      }
  }


}
